import {
  CHECK_PARSE_RULE,
  DOCUMENT_PARSE_RULE,
  INVOICE_PARSE_RULE,
} from './parser';
import type { DocumentImporterConfig } from './types';

const DOCUMENT_MANUAL_FIELDS: DocumentImporterConfig['manualFormFields'] = [
  { key: 'folio', label: 'Folio', placeholder: 'ej. 001234', required: true },
  {
    key: 'stakeholderIdentifier',
    label: 'RUT',
    placeholder: '12.345.678-9',
    required: true,
  },
  {
    key: 'issuedDate',
    label: 'Fecha de emisión',
    placeholder: 'dd-mm-aaaa',
    required: true,
  },
  { key: 'amount', label: 'Monto', required: true },
];

const DOCUMENT_EXCEL_MAPPING: Record<string, string> = {
  Folio: 'folio',
  RUT: 'stakeholderIdentifier',
  Fecha: 'issuedDate',
  Monto: 'amount',
};

const DOCUMENT_EXPECTED_COLUMNS = ['Folio', 'RUT', 'Fecha', 'Monto'];

const CHECK_MANUAL_FIELDS: DocumentImporterConfig['manualFormFields'] = [
  ...DOCUMENT_MANUAL_FIELDS,
  {
    key: 'stakeholderName',
    label: 'Razón social',
    placeholder: 'Ejemplo SPA.',
    required: false,
  },
];

export const INVOICE_IMPORTER_CONFIG: DocumentImporterConfig = {
  title: 'Importar facturas',
  allowExcelUpload: true,
  manualFormFields: [
    {
      key: 'type',
      label: 'Tipo de documento',
      placeholder: 'Seleccionar tipo',
      required: true,
    },
    { key: 'folio', label: 'Folio', placeholder: 'ej. 001234', required: true },
    {
      key: 'stakeholderIdentifier',
      label: 'RUT',
      placeholder: '12.345.678-9',
      required: true,
    },
    {
      key: 'issuedDate',
      label: 'Fecha de emisión',
      placeholder: 'dd-mm-aaaa',
      required: true,
    },
    { key: 'amount', label: 'Monto', required: true },
  ],
  documentTypeOptions: [
    { value: 'electronic-invoice', label: 'Factura electrónica' },
    { value: 'electronic-invoice-exempt', label: 'Factura exenta' },
    { value: 'electronic-invoice-buyer', label: 'Factura de compra' },
  ],
  excelColumnMapping: {
    Tipo: 'type',
    Folio: 'folio',
    RUT: 'stakeholderIdentifier',
    Fecha: 'issuedDate',
    Monto: 'amount',
  },
  expectedExcelColumns: ['Tipo', 'Folio', 'RUT', 'Fecha', 'Monto'],
  validateWithSII: true,
  parseRule: INVOICE_PARSE_RULE,
  templateKey: 'invoice',
};

export const DOCUMENT_IMPORTER_CONFIG: DocumentImporterConfig = {
  title: 'Importar documentos',
  allowExcelUpload: false,
  manualFormFields: DOCUMENT_MANUAL_FIELDS,
  excelColumnMapping: DOCUMENT_EXCEL_MAPPING,
  expectedExcelColumns: DOCUMENT_EXPECTED_COLUMNS,
  parseRule: DOCUMENT_PARSE_RULE,
  templateKey: 'document',
};

export const CHECK_IMPORTER_CONFIG: DocumentImporterConfig = {
  title: 'Importar cheques',
  allowExcelUpload: true,
  manualFormFields: CHECK_MANUAL_FIELDS,
  excelColumnMapping: DOCUMENT_EXCEL_MAPPING,
  expectedExcelColumns: DOCUMENT_EXPECTED_COLUMNS,
  parseRule: CHECK_PARSE_RULE,
  templateKey: 'check',
};

const CONFIG_BY_CATEGORY: Record<string, DocumentImporterConfig> = {
  invoice: INVOICE_IMPORTER_CONFIG,
  check: CHECK_IMPORTER_CONFIG,
};

const DEFAULT_IMPORTER_CONFIG = DOCUMENT_IMPORTER_CONFIG;

export function getImporterConfigForCategory(
  category: string | undefined,
): DocumentImporterConfig {
  if (!category) return DEFAULT_IMPORTER_CONFIG;
  return CONFIG_BY_CATEGORY[category] ?? DEFAULT_IMPORTER_CONFIG;
}
